import React, {useState} from "react";
import {SUMMARY_ALL, SUMMARY_OTHERS, SUMMARY_PROJECTS, SUMMARY_SELF_INTRODUCTION} from "../../actions/path";
import AllSummary2 from "./allSummary2";
import {BTN_KEY} from "../../util/util";
import Header from "../Header";

const Summary2 = () => {
    const [btnKey, setBtnKey] = useState(BTN_KEY.DEFAULT);
    const content = {
        mainText: 'Always with Passion',
        subText: '개발자 이준복을 소개합니다.',
        introText: '소개',
        projectText: '프로젝트',
        specText: '스펙',
        allShowText: '전체보기'
    }

    const changeBtnKey = (value) => {
        setBtnKey(value);
    }

    return (
        <>
            <div className="position-relative overflow-hidden p-3 p-md-5 m-md-3 text-center slogan-bg">
                <div className="col-md-10 p-lg-5 mx-auto my-2">
                    <h1 className="display-6 fw-bold slogan-main-text fade-item delay-1">
                        {content.mainText}
                    </h1>
                    <h3 className="fw-normal text-muted mb-3 fade-item delay-3">
                        {content.subText}
                    </h3>
                    <div className="d-flex gap-3 justify-content-center lead fw-normal fade-item delay-5">
                        <div className="dashboadr-btn-grop d-flex gap-4 mt-3">
                            <button type="button"
                                    className={`dashboard-custom-btn btn btn-${btnKey === BTN_KEY.INTRO ? 'dark' : 'light'}`}
                                    onClick={() => {
                                        setBtnKey(BTN_KEY.INTRO);
                                    }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                     className="bi bi-person-raised-hand" viewBox="0 0 16 16">
                                    <path
                                        d="M6 6.207v9.043a.75.75 0 0 0 1.5 0V10.5a.5.5 0 0 1 1 0v4.75a.75.75 0 0 0 1.5 0v-8.5a.25.25 0 1 1 .5 0v2.5a.75.75 0 0 0 1.5 0V6.5a3 3 0 0 0-3-3H6.236a1 1 0 0 1-.447-.106l-.33-.165A.83.83 0 0 1 5 2.488V.75a.75.75 0 0 0-1.5 0v2.083c0 .715.404 1.37 1.044 1.689L5.5 5c.32.32.5.754.5 1.207"></path>
                                    <path d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"></path>
                                </svg>
                                {content.introText}
                            </button>
                            <button type="button"
                                    className={`dashboard-custom-btn btn btn-${btnKey === BTN_KEY.PROJECT ? 'dark' : 'light'}`}
                                    onClick={() => {
                                        setBtnKey(BTN_KEY.PROJECT);
                                    }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                     className="bi bi-stack" viewBox="0 0 16 16">
                                    <path
                                        d="m14.12 10.163 1.715.858c.22.11.22.424 0 .534L8.267 15.34a.6.6 0 0 1-.534 0L.165 11.555a.299.299 0 0 1 0-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.66zM7.733.063a.6.6 0 0 1 .534 0l7.568 3.784a.3.3 0 0 1 0 .535L8.267 8.165a.6.6 0 0 1-.534 0L.165 4.382a.299.299 0 0 1 0-.535z"></path>
                                    <path
                                        d="m14.12 6.576 1.715.858c.22.11.22.424 0 .534l-7.568 3.784a.6.6 0 0 1-.534 0L.165 7.968a.299.299 0 0 1 0-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0z"></path>
                                </svg>
                                {content.projectText}
                            </button>
                            <button type="button"
                                    className={`dashboard-custom-btn btn btn-${btnKey === BTN_KEY.SPEC ? 'dark' : 'light'}`}
                                    onClick={() => {
                                        setBtnKey(BTN_KEY.SPEC);
                                    }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                     className="bi bi-person-vcard" viewBox="0 0 16 16">
                                    <path
                                        d="M5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m4-2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M9 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 9 8m1 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5"></path>
                                    <path
                                        d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8.96q.04-.245.04-.5C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1 1 0 0 1 1 12z"></path>
                                </svg>
                                {content.specText}
                            </button>
                            <button type="button"
                                    className={`dashboard-custom-btn btn btn-${btnKey === BTN_KEY.ALL ? 'dark' : 'light'}`}
                                    onClick={() => {
                                        setBtnKey(BTN_KEY.ALL);
                                    }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                     className="bi bi-check-all" viewBox="0 0 16 16">
                                    <path
                                        d="M8.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L2.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093L8.95 4.992zm-.92 5.14.92.92a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 1 0-1.091-1.028L9.477 9.417l-.485-.486z"></path>
                                </svg>
                                {content.allShowText}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="product-device shadow-sm d-none d-md-block">
                </div>
                <div className="product-device product-device-2 shadow-sm d-none d-md-block">
                </div>
            </div>
            <AllSummary2 btnKey={btnKey} changeBtnKey={changeBtnKey}/>
        </>
    )
}

export default Summary2;